import { Cookie } from './cookies';
import { getTokenKey } from './getTokenKey';

export const setS3Token = (token: string): Promise<string | null> => new Promise((resolve, reject) => {
  try {
    const tokenKey = getTokenKey(true);
    Cookie.set(tokenKey, token, 60);
    localStorage.setItem(tokenKey, token);
    resolve(token);
  } catch (error) {
    reject(error);
  }
});
